module.exports = __webpack_public_path__ + "assets/img/pic_04.dd0488dd.png";